import AboveAverageBadge from '@/components/badges/above-average-badge/above-average-badge';
import AverageBadge from '@/components/badges/average-badge/average-badge';
import BelowAverageBadge from '@/components/badges/below-average-badge/below-average-badge';
import AboveAverageImpactBadge from './components/above-average-impact-badge';
import AverageImpactBadge from './components/average-impact-badge';
import BelowAverageImpactBadge from './components/below-average-impact-badge';
import { RISK_UPPER_THRESHOLD, RISK_LOWER_THRESHOLD } from '@/constants/risks';

export default function getBadgeAndProgressBarVariant(impact: number, average: number) {
  if (impact > average * RISK_UPPER_THRESHOLD)
    return {
      TextBadgeComponent: AboveAverageBadge,
      ImpactBadgeComponent: AboveAverageImpactBadge,
      progressBarVariant: 'error',
    };

  if (impact < average * RISK_LOWER_THRESHOLD)
    return {
      TextBadgeComponent: BelowAverageBadge,
      ImpactBadgeComponent: BelowAverageImpactBadge,
      progressBarVariant: 'success',
    };

  return { TextBadgeComponent: AverageBadge, ImpactBadgeComponent: AverageImpactBadge, progressBarVariant: 'warning' };
}
